<template lang="pug">
  section#game.section(:class="{'play': isReady}" data-pv="game")
    .section__outer

    .section__inner

      .game__logo(v-show="currentPart < 7")

      transition(name="fade" mode="out-in")
        GamePart1(v-if="currentPart === 1" :changePart="changePart")
        GamePart2(v-else-if="currentPart === 2" :changePart="changePart" :isRecording="isRecording")
        GamePart3(v-else-if="currentPart === 3" :changePart="changePart" :toggleBpm="toggleBpm" :bpm="bpm")
        GamePart4(v-else-if="currentPart === 4" :changePart="changePart")
        GamePart5(v-else-if="currentPart === 5" :changePart="changePart")
        GamePart6(v-else-if="currentPart === 6" :changePart="changePart")
        GamePart7(v-else-if="currentPart === 7" :changePart="changePart")

      transition(name="fade" mode="out-in")
        .game__wave(v-if="currentPart >= 3 && currentPart <= 5" style="display: flex; align-items: center; justify-content: center;")
          transition(name="fade" mode="out-in")
            iframe.game__wave__iframe(
              v-if="animationIndex === 0"
              src="./animation/wave/a_HTML5 Canvas.html",
              allowtransparency="true",
              scrolling="no",
              frameborder="0"
              :class="{'game__wave__iframe--loaded': isIframeLoaded[0]}"
              @load="iframeOnLoad(0)"
            )
            iframe.game__wave__iframe(
              v-else-if="animationIndex === 1"
              src="./animation/wave/b_HTML5 Canvas.html",
              allowtransparency="true",
              scrolling="no",
              frameborder="0"
              :class="{'game__wave__iframe--loaded': isIframeLoaded[1]}"
              @load="iframeOnLoad(1)"
            )
            iframe.game__wave__iframe(
              v-else-if="animationIndex === 2"
              src="./animation/wave/c_HTML5 Canvas.html",
              allowtransparency="true",
              scrolling="no",
              frameborder="0"
              :class="{'game__wave__iframe--loaded': isIframeLoaded[2]}"
              @load="iframeOnLoad(2)"
            )
            iframe.game__wave__iframe(
              v-else-if="animationIndex === 3"
              src="./animation/wave/d_HTML5 Canvas.html",
              allowtransparency="true",
              scrolling="no",
              frameborder="0"
              :class="{'game__wave__iframe--loaded': isIframeLoaded[3]}"
              @load="iframeOnLoad(3)"
            )
        

      //- video.game__video(playsinline preload muted loop autoplay)
      //-   source(type="video/mp4" src="/videos/wave.mp4")

      a.game__round-button.game__round-button--start.move-in(v-if="currentPart === 1" href="#" @click.prevent="getCameraPermission(); $trackEvent('step1', 'click_button', 'step1_start');" style="transition-delay: .2s")
        span 開始

      //- .game__round-button.game__round-button--capture(v-if="currentPart === 2" @click.prevent="changePart(3)")
      .game__round-button.game__round-button--capture(v-show="currentPart >= 2 && currentPart <= 3")
        //- :class="{'game__round-button--hide': currentPart === 3}"
        .game__round-button__camera
          video.game__video(ref="video" autoplay="autoplay" playsinline)
          canvas.game__canvas(ref="canvas")

      .game__round-button.game__round-button--recording(v-if="currentPart === 3")
        .game__round-button__score
          span.game__round-button__number {{ showBpm ? bpm : '---' }}
          span.game__round-button__unit 次 / 分

      .game__round-progress(v-if="currentPart === 3")
        svg.circular(viewBox='25 25 50 50')
          circle.path(cx='50' cy='50' fill='none' r='23.5' stroke-miterlimit='10' stroke-width='2.4')

      //- .game__brightness(style="position: fixed; top: 0; left: 0;") BPM Value: {{ bpm }}

</template>

<script>
import { mapState, mapActions } from 'vuex'
import { mixins } from '@/utils/mixins'
import GamePart1 from '../components/GamePart1.vue'
import GamePart2 from '../components/GamePart2.vue'
import GamePart3 from '../components/GamePart3.vue'
import GamePart4 from '../components/GamePart4.vue'
import GamePart5 from '../components/GamePart5.vue'
import GamePart6 from '../components/GamePart6.vue'
import GamePart7 from '../components/GamePart7.vue'

export default {
  name: 'Game',
  mixins: [mixins],
  props: {
  },
  watch: {
    isLoading() {
      this.init();
    },
    currentPart(newValue) {
      const { getCameraPermission, startVideo, startAnimationTimer, stopAnimationTimer, stopVideo } = this;
      if (newValue === 2) {
        this.$nextTick(() => {
          startVideo(this.$refs.video, true);
        });
      }
      if (newValue === 3) startAnimationTimer();
      if (newValue === 4) {
        this.isPaused = true;
        stopVideo();
      }
      if (newValue > 5) stopAnimationTimer();
    },
  },
  data: () => {
    return {
      isReady: false,
      isPaused: false,
      isRecording: false,
      isReminded: false,
      currentPart: 1,
      animationIndex: null,
      animationTimer: null,
      isIframeLoaded: [false, false, false, false],
      raf: null,
      brightness: 0,
      sampleBuffer: [],
      maxSamples: 60 * 10,
      showBpm: false,
      bpm: 0,
      bpmMax: 140,
      bpmMin: 60,
      bpmArray: [],
    }
  },
  computed: {
    ...mapState(['isLoading']),
  },
  methods: {
    ...mapActions([]),
    init() {
      this.isReady = true;
    },
    startAnimationTimer() {
      this.animationIndex = 0;
      this.animationTimer = setInterval(() => {
        this.$set(this.isIframeLoaded, this.animationIndex % 4, false);
        this.animationIndex = (this.animationIndex + 1) % 4;
      }, 4000);
    },
    stopAnimationTimer() {
      clearInterval(this.animationTimer);
    },
    changePart(value) {
      // const { startAnimationTimer, stopAnimationTimer } = this;
      this.currentPart = value;
      // if (this.currentPart === 3) startAnimationTimer();
      // if (this.currentPart > 5) stopAnimationTimer();
    },
    toggleBpm(bool) {
      this.showBpm = bool;
    },
    iframeOnLoad(index) {
      this.$set(this.isIframeLoaded, index, true);
    },
    // 取得鏡頭權限
    async getCameraPermission() {
      const { startVideo, changePart, recording } = this;
      const { video } = this.$refs;
      startVideo(video, false).then((resp) => {
        if (!resp.status) {
          this.$toast.error('請重新整理網頁並允許取用鏡頭權限，以進行完整互動體驗。')
          this.$router.push('/')
          return false;
        }
        changePart(2);
        // this.isRecording = true;
        // recording();
      });
    },
    async getDevices() {
      const mediaDevices = await navigator.mediaDevices.enumerateDevices();
      const devices = mediaDevices.filter((device) => device.kind === 'videoinput');
      return devices;
    },
    startVideo(video, hasPermission) {
      const { getDevices, stopVideo } = this;
      stopVideo();
      return new Promise((resolve, reject) => {
        if (!video) { resolve({ status: false, msg: '請提供一個有效的 video 元素' }); }

        video.width = video.width || 640;

        getDevices().then(devices => {
          const mainCamera = devices.filter(device => device.kind === 'videoinput' && (device.label === 'Back Dual Camera' || device.label === '後置雙鏡頭相機'))[0]; // FaceTime HD Camera
          const deviceId = mainCamera ? { exact: mainCamera.deviceId } : undefined;
          if (mainCamera) console.log(mainCamera, deviceId, mainCamera.label);
          navigator.mediaDevices
            .getUserMedia({
              audio: false,
              video: {
                deviceId,
                facingMode: 'environment',
              },
            })
            .then((stream) => {
              window.localStream = stream;
              video.srcObject = stream;
              video.onloadedmetadata = () => {
                video.height = video.width * (video.videoHeight / video.videoWidth);
                video.style.height =
                  parseInt(video.style.width) *
                  (video.videoHeight / video.videoWidth).toFixed(2) +
                  'px';
                video.play();
                resolve({ status: true, msg: '鏡頭模組已成功初始化' });
              };
              if (hasPermission) {
                this.isRecording = true;
                this.recording();
              }
            })
            .catch(function (err) { resolve({ status: false, msg: err }); });
        })
      });
    },

    async stopVideo() {
      if (window.localStream) {
        window.localStream.getTracks().forEach((track) => {
          track.stop();
        });
        window.localStream = null;
      }
    },

    recording() {

      if (!this.isRecording) {this.isRecording = true;}

      if (this.isPaused) {
        window.cancelAnimationFrame(this.raf);
        return;
      }

      const { currentPart, recording, getPixelData, isPaused } = this;
      const { canvas, video } = this.$refs;
      const media = video;

      canvas.width = media.width;
      canvas.height = media.height;

      const ctx = canvas.getContext('2d');
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(media, 0, 0, canvas.width, canvas.height);

      if (currentPart === 3) getPixelData();
      if (media && !isPaused) this.raf = window.requestAnimationFrame(recording);

    },
    getPixelData() {
      const { analyzeData, calculateBpm, bpmMax, bpmMin } = this;
      const { canvas } = this.$refs;
      const ctx = canvas.getContext('2d');
      const pixelData = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
      let sum = 0;
      let r = 0;
      let g = 0;
      let b = 0;
      for (let i = 0; i < pixelData.length; i += 4) {
        sum = sum + pixelData[i] + pixelData[i + 1] + pixelData[i + 2];
        r = r + pixelData[i];
        g = g + pixelData[i + 1];
        b = b + pixelData[i + 2];
      }
      if (g + b >= r && !this.isReminded && this.showBpm) {
        this.isReminded = true;
        this.$toast('未偵測到手指，請勿離開鏡頭，或嘗試移至其他鏡頭，以準確判讀心跳', { timeout: 5000 });
      }
      const avg = sum / (pixelData.length * 0.5)
      // const avg = sum / (pixelData.length * 0.25)
      this.brightness = avg / 255;

      const value = this.brightness
      const time = Date.now();

      this.sampleBuffer.push({ value, time });
      if (this.sampleBuffer.length > this.maxSamples) this.sampleBuffer.shift();

      const dataStats = analyzeData(this.sampleBuffer);
      let calculateResult = +calculateBpm(dataStats.crossings);

      if (calculateResult > bpmMax) calculateResult = bpmMax;
      if (calculateResult < bpmMin) calculateResult = bpmMin;

      this.bpmArray.push(calculateResult);
      if (!this.bpmArray.length) {
        this.bpm = calculateResult;
      } else {
        this.bpm = +((this.bpmArray.reduce((a, c) => a + c) / this.bpmArray.length).toFixed());
      }

      // if (calculateResult > bpmMax) {
      //   this.bpm = bpmMax;
      // } else if (calculateResult < bpmMin && !this.bpmArray.length) {
      //   this.bpm = bpmMin;
      // } else {
      //   if (calculateResult > 60 && calculateResult < 140) this.bpmArray.push(calculateResult);
      //   if (!this.bpmArray.length) {
      //     this.bpm = calculateResult;
      //   } else {
      //     this.bpm = +((this.bpmArray.reduce((a, c) => a + c) / this.bpmArray.length).toFixed());
      //   }
      // }

    },
    // goToNextPage() {
    //   this.$router.push('/next');
    // },

    analyzeData(samples) {
      const { getAverageCrossings } = this;

      // 取得樣本的平均值
      const average =
        samples.map((sample) => sample.value).reduce((a, c) => a + c) /
        samples.length;

      // 取得最大值與最小值
      let min = samples[0].value;
      let max = samples[0].value;
      samples.forEach((sample) => {
        if (sample.value > max) {
          max = sample.value;
        }
        if (sample.value < min) {
          min = sample.value;
        }
      });

      // 數值變化範圍
      // const range = max - min;

      const crossings = getAverageCrossings(samples, average);

      return {
        average,
        min,
        max,
        // range,
        crossings,
      };
    },

    getAverageCrossings(samples, average) {
      // Get each sample at points where the graph has crossed below the average level
      // These are visible as the rising edges that pass the midpoint of the graph
      const crossingsSamples = [];
      let previousSample = samples[0]; // Avoid if statement in loop

      samples.forEach(function (currentSample) {
        // 檢查下一個樣本是否低於平均值
        if (
          currentSample.value < average &&
          previousSample.value > average
        ) {
          crossingsSamples.push(currentSample);
        }

        previousSample = currentSample;
      });

      return crossingsSamples;
    },

    calculateBpm(samples) {
      if (samples.length < 2) {
        return this.bpm;
      }

      const averageInterval =
        (samples[samples.length - 1].time - samples[0].time) /
        (samples.length - 1);
        // (samples.length - 0);

      return (60000 / averageInterval).toFixed();
    },

    preloadIframe() {
      const array = [
        './animation/wave/a_HTML5 Canvas.html',
        './animation/wave/b_HTML5 Canvas.html',
        './animation/wave/c_HTML5 Canvas.html',
        './animation/wave/d_HTML5 Canvas.html',
        './animation/brand/index.html',
        './animation/heart/index.html',
        './animation/richart/run_HTML5 Canvas.html',
      ];
      array.forEach(item => {
        const elem = document.createElement('iframe');
        elem.setAttribute('src', item);
        elem.style.width = 0;
        elem.style.height = 0;
        elem.onload = () => { elem.remove(); }
        document.body.appendChild(elem);
      })
    },

  },
  created() {
  },
  mounted() {
    const { init, isLoading, isReady, preloadIframe } = this;
    if (!isLoading && !isReady) setTimeout(init, 500);
    // setTimeout(() => { if (!isLoading) init() }, 1000)
    preloadIframe();
  },
  beforeDestroy() {
    this.isPaused = true;
  },
  destroyed() {
    const { stopAnimationTimer, stopVideo } = this;
    stopAnimationTimer();
    stopVideo();
  },
  components: {
    GamePart1,
    GamePart2,
    GamePart3,
    GamePart4,
    GamePart5,
    GamePart6,
    GamePart7,
  }
}
</script>

<style lang="scss">

$assets: '~@/assets/images/game/';

#game {

  height: calc(var(--vh, 1vh) * 100);
  min-height: vw(1250);
  overflow: hidden;

  @include desktop {
    height: calc(var(--vh, 1vh) * 100);
  }

  .section__inner {

    position: relative;

    @include desktop {
      height: 100%;
    }

  }

  .game__logo {
    position: absolute;
    top: vw(46);
    left: vw(274);
    width: vw(203);
    height: vw(63);
    background: url($assets + 'logo.png') no-repeat 0 0 / contain;
  }

  .game__wave {
    position: absolute;
    top: vw(239);
    left: 0;
    width: vw(750);
    height: vw(296);
    // background: #000;
    iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: auto;
      visibility: hidden;
      transform: scale(1.05);
      &.game__wave__iframe--loaded {
        visibility: visible;
      }
    }
  }

  .game__round-button {
    display: flex;
    align-items: center;
    justify-content: center;

    position: absolute;
    top: vw(745);
    left: vw(214);
    width: vw(318);
    height: vw(318);
    border: #5f123e vw(16) solid;
    border-radius: 50%;
    box-shadow:
      #fff inset 0 0 0 vw(3),
      rgba(#ff47bc, .5) 0 0 .25em,
      rgba(#ff47bc, .5) 0 0 .5em,
      rgba(#ff47bc, .5) 0 0 .75em;
    overflow: hidden;

    span {
      color: #fff;
      font-size: vw(47);
      font-weight: 400;
      letter-spacing: vw(letterSpacing(600, 47));
      text-indent: vw(letterSpacing(600, 47));
      @include narrow-text;
      @include neon-text;
    }
  }

  .game__round-button--start::after {
    content: '';
    position: absolute;
    top: vw(163);
    left: 50%;
    width: vw(51);
    height: vw(40);
    margin-left: vw(-25.5);
    background: url('~@/assets/images/game/part-1/button-arrow.png') no-repeat 0 0 / contain;
    animation: buttonArrow 1s ease-in-out infinite;
  }

  .game__round-button--capture {
    transform: translate3d(0,0,0);
  }

  .game__round-button--capture .game__round-button__camera {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background: #000;
    z-index: -1;
  }

  .game__round-button--recording {
    z-index: 1;
  }

  .game__round-button--recording .game__round-button__score {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(#ec4c3b, .3);
    z-index: -1;

    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    span {
      text-indent: 0;
      letter-spacing: 0;
    }

    .game__round-button__number {
      font-size: vw(65);
      font-weight: 500;
      line-height: 1;
      letter-spacing: vw(letterSpacing(100, 65));
      padding-left: vw(letterSpacing(100, 65));
    }

    .game__round-button__unit {
      font-size: vw(27);
      letter-spacing: vw(letterSpacing(200, 27));
      padding-top: vw(20);
      padding-bottom: vw(10);
      padding-left: vw(letterSpacing(200, 27));
    }
  }

  .game__round-button--hide {
    opacity: 0;
    pointer-events: none;
  }

  .game__round-progress {

      position: absolute;
      top: vw(745);
      left: vw(214);
      width: vw(318);
      height: vw(318);
      z-index: 2;

      .circular {

          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 100%;
          margin: auto;
          transform: rotate(-90deg);
          // animation: rotate 2s linear infinite;
          transform-origin: center center;
          // filter: drop-shadow(0 0 vw(15) #ff47bc);

          .path {
              stroke: #fff;
              stroke-dasharray: 1, 200;
              stroke-dashoffset: 0;
              animation: progressDash 14.25s linear 1 forwards;
              stroke-linecap: round;
          }

          @keyframes progressDash {
            0% {
              stroke-dasharray: 1, 200;
              stroke-dashoffset: 0;
            }
            100% {
              stroke-dasharray: 200, 200;
              stroke-dashoffset: 0;
            }
          }

      }

  }


  .game__button {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: vw(438);
    height: vw(72);
    border-radius: vw(72);
    background: #d70d1a;

    span {
      color: #ffffff;
      font-size: vw(30);
      font-weight: 600;
      letter-spacing: vw(letterSpacing(300, 30));
      @include narrow-text;
    }
  }

  .game__video {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    // transform: scale(-1, 1);
  }

  .game__canvas {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,1);
    object-fit: cover;
  }

  // .game__caption {
  //   position: absolute;
  //   top: vw(336);
  //   left: vw(88);
  //   width: vw(563);
  //   height: vw(304);
  //   // background: url($assets + 'caption.png') no-repeat 0 0 / contain;
  //   @include hide-text;
  // }

}

</style>
